import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import icon from "../../assets/icon.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <Link to="/">
          {" "}
          {/* Wrap the image with the Link component and set 'to' prop to the home path */}
          <img src={icon} alt="TifFoo Logo" className="logo-image" />
        </Link>
      </div>

      {/* Desktop Links - Using NavLink for active highlighting */}
      <ul className="nav-links">
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            HOME
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/menu"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            MENU
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/comingsoon"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            OFFERS
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            CONTACT US
          </NavLink>
        </li>
      </ul>

      {/* Desktop Button */}
      <div className="nav-button">
        <Link to="/comingsoon" style={{ textDecoration: "none" }}>
          <button>
            Get the App <span>↗</span>
          </button>
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <div
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Mobile Menu - Optional: Use NavLink here too for consistency */}
      {menuOpen && (
        <ul className="mobile-menu">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "mobile-nav-link active" : "mobile-nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/menu"
              className={({ isActive }) =>
                isActive ? "mobile-nav-link active" : "mobile-nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              MENU
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/comingsoon"
              className={({ isActive }) =>
                isActive ? "mobile-nav-link active" : "mobile-nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              OFFERS
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "mobile-nav-link active" : "mobile-nav-link"
              }
              onClick={() => setMenuOpen(false)}
            >
              CONTACT US
            </NavLink>
          </li>
          <li>
            <Link
              to="/comingsoon"
              style={{ textDecoration: "none", width: "100%" }}
            >
              <button
                style={{ width: "100%", textAlign: "center" }}
                onClick={() => setMenuOpen(false)}
              >
                Get the App <span>↗</span>
              </button>
            </Link>
          </li>
        </ul>
      )}

      {/* Styles Section */}
      <style jsx>{`
        .navbar {
          margin-top: 2rem;
          position: fixed;
          width: calc(100% - 4rem);
          background-color: #ffffff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 50;
          border-bottom-left-radius: 30px;
          border-bottom-right-radius: 30px;
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
          height: 4rem;
          margin-right: 2rem;
          margin-left: 2rem;
        }

        .logo {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .logo-image {
          height: 3rem;
          width: auto;
          object-fit: contain;
          margin-left: 20px;
          margin-right: 250px;
        }

        .nav-links {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 3rem;
        }

        .nav-link {
          color: #f97316;
          text-decoration: none;
          font-weight: 600;
          text-transform: uppercase;
          transition: color 0.3s ease;
          font-family: "Poppins", sans-serif;
          font-size: 1rem;
        }

        .nav-link:hover {
          color: #ea580c;
        }

        .nav-link.active {
          color: #ea580c;
          font-weight: 700;
          border-bottom: 2px solid #f97316;
        }

        .nav-button {
          display: flex;
          align-items: center;
          margin-right: 5rem;
        }

        .nav-button button {
          padding: 0.5rem 1rem;
          border: 2px solid #2d3748;
          border-radius: 0.5rem;
          background-color: transparent;
          color: #2d3748;
          font-weight: 600;
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: background-color 0.3s ease, color 0.3s ease;
          font-family: "Poppins", sans-serif;
          font-size: 0.9rem;
        }

        .nav-button button:hover {
          background-color: #f97316;
          color: #ffffff;
          border-color: #f97316;
        }

        .nav-button button span {
          margin-left: 0.25rem;
        }

        .mobile-menu-toggle {
          display: none;
          font-size: 1.8rem;
          color: #f97316;
          cursor: pointer;
          transition: transform 0.3s ease;
          margin-left: 17rem;
        }

        .mobile-menu-toggle:hover {
          transform: scale(1.1);
        }

        /* Mobile Menu */
        .mobile-menu {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          position: absolute;
          top: 4rem;
          left: 0;
          width: 100%;
          background: #ffffff;
          border-bottom-left-radius: 2rem;
          border-bottom-right-radius: 2rem;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          list-style: none;
          padding: 1rem 1.5rem;
          margin: 0;
          z-index: 40;
          animation: slideDown 0.3s ease forwards;
        }

        .mobile-menu li {
          width: 100%;
          border-bottom: 1px solid #f1f1f1;
          text-align: right;
        }

        .mobile-menu li:last-child {
          border-bottom: none;
        }

        .mobile-nav-link {
          color: #f97316;
          text-decoration: none;
          font-weight: 600;
          text-transform: uppercase;
          padding: 1rem 0;
          display: block;
          font-family: "Poppins", sans-serif;
          font-size: 1.1rem;
          transition: color 0.3s ease, background 0.3s ease;
          width: 100%;
          text-align: center;
        }

        .mobile-nav-link:hover {
          color: #fff;
          background: #f97316;
        }

        .mobile-nav-link.active {
          color: #ea580c;
          font-weight: 700;
          background: rgba(249, 115, 22, 0.1);
        }

        .mobile-menu li button {
          border: none;
          background: none;
          cursor: pointer;
        }

        /* Slide-down Animation */
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .nav-links,
          .nav-button {
            display: none;
          }

          /* Mobile hamburger toggle */
          .mobile-menu-toggle {
            display: block;
            margin-left: auto;
            margin-right: 1.5rem;
          }

          /* Logo on left and smaller */
          .logo {
            position: absolute;
            left: 1.8rem;
            top: 50%;
            transform: translateY(-50%);
            height: 0;
          }

          .logo-image {
            height: 2.5rem !important;
            width: auto;
            margin-left: -0.5rem;
            margin-right: 0;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
